export default __webpack_public_path__ + "static/media/folder.3597d027.svg";